import cms from "redbay-b2b-cms/src/Cms";

export default {

    buildResult(searchResult, prices, commercials) {
        return {
            page: searchResult.page,
            products: searchResult.documentList.map((el) => {
                return this.buildProduct(el, prices, commercials)
            }),
            filters: this.buildFilters(searchResult)
        }
    },

    buildFilter(searchProduct, aggregationName) {
        let agg = searchProduct.aggregationList.find((el) => el.field == aggregationName);
        if (agg != null) {
            return agg.aggregationValueList.map((v) => v.name).sort();
        }
        return [];
    },

    buildProduct(searchProduct, attributes, prices, group) {
        let product = {
            id: searchProduct.Id,
            code: searchProduct.Code,
            unit: searchProduct.Unit.Name,
            variantId: this.getVariantId(searchProduct),
            url: this.getUrl(searchProduct),
            name: this.getName(searchProduct),
            image: this.getPhoto(searchProduct),
            tax: this.getTax(searchProduct),
            clientPrice: this.getClientPrice(searchProduct, prices, group),
            netPrice: this.getClientPrice(searchProduct, prices, ''),
            stock: this.getClientPrice(searchProduct, prices, group) ? this.getStock(searchProduct) : 0,
            producer: this.getProducer(searchProduct),
            ean: this.getEan(searchProduct),
        };

        for(let attributeName of attributes) {
            product[attributeName] = this.getAttributeValue(searchProduct,attributeName)
        }
        return product;
    },

    buildProductView(product, prices, group) {
        return {
            id: product.Id,
            variantId: this.getVariantId(product),
            code: product.Code,
            name: this.getName(product),
            tax: this.getTax(product),
            unit: product.Unit.Name,
            clientPrice: this.getClientPrice(product, prices, group),
            netPrice: this.getClientPrice(product, prices, ''),
            stock: this.getClientPrice(product, prices, group) ? this.getStock(product) : 0,
            producer: this.getProducer(product),
            producerId: this.getProducerId(product),
            attributes: this.getAttributes(product),
            images: this.getViewPhotos(product),
            attachment: this.getAttachmentUrl(product),
            categories: this.getCategories(product),
        }
    },

    getCategories(searchProduct){
        return searchProduct.CategoryList;
    },

    getAttachmentUrl(searchProduct){
        return searchProduct.AttachmentUrl;
    },

    getVariantId(searchProduct) {
        return searchProduct.VariantList.length > 0 ? searchProduct.VariantList[0].Id : 0;
    },

    getUrl(searchProduct) {
        let name = this.getName(searchProduct);
        return '/pl/product/' + searchProduct.Id + '/' +
            name.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-").replace(/%/g, "-").replace(/'/g, "-").replace(/\\/g, "-");
    },

    getName(searchProduct) {
        const languageId = 1;
        let translate = searchProduct.TranslationList
            .find((el) => {
                return el.Active == 'Y' && el.Type == 'N' && el.Language == languageId
            });
        return translate != null &&  translate.ValueString != null? translate.ValueString.replace(/\\'/g, "'") : "";
    },

    getPhoto(searchProduct) {
        for (let variant of searchProduct.VariantList) {
            for (let photo of variant.PhotoList) {
                return cms.replaceSizePhoto(photo.Url, 300, 300);
            }
        }
        if (searchProduct.PhotoList.length > 0) {
            return cms.replaceSizePhoto(searchProduct.PhotoList[0].Url, 300, 300);
        }

        return '//cdn01.redbay.pl/layouts/boma/img/noimg.jpg';
    },

    getViewPhotos(searchProduct) {
        let photos = [];
        if (searchProduct.VariantList) {
            for (let variant of searchProduct.VariantList) {
                for (let photo of variant.PhotoList) {
                    photos.push({
                        view: cms.replaceSizePhoto(photo.Url, 600, 600),
                        org: photo.Url
                    });
                }
            }
        } else {
            for (let photo of searchProduct.PhotoList) {
                photos.push({
                    view: cms.replaceSizePhoto(photo.Url, 600, 'org'),
                    org: photo.Url
                });
            }
        }

        if (photos.length == 0) {

            for (let photo of searchProduct.PhotoList) {
                photos.push({
                    view: cms.replaceSizePhoto(photo.Url, 600, 'org'),
                    org: photo.Url
                });
            }
        }

        if (photos.length == 0) {
            photos.push({
                view: 'http://ls8.redbay.pl/layouts/boma/img/noimg.jpg',
                org: 'http://ls8.redbay.pl/layouts/boma/img/noimg.jpg'
            })
        }
        return photos;
    },

    getTax(searchProduct) {
        return Number(searchProduct.Tax.Percent);
    },


    getClientPrice(searchProduct, prices, group) {
        let variant = this.getDefaultVariant(searchProduct);
        try {
            let price = 0;
            if(typeof prices === 'object') {
                price = prices[variant.Id] ? prices[variant.Id] : 0;
            }
            return price ? price : this.getIphPrice(searchProduct, group);
        } catch (err) {
            return this.getIphPrice(searchProduct, group);
        }
    },

    getIphPrice(searchProduct, group) {
        let settingValue = searchProduct.SettingValueList.find(s => s.Setting.Groups.find(g =>g.Id == group) != null);
        let variant = this.getDefaultVariant(searchProduct);
        if (settingValue) {
            let discountGroup = Number(settingValue.Setting.Profit) +  Number(settingValue.Setting.Discount);
            discountGroup = discountGroup > 0 ? discountGroup / 100 : 1;
            // let price =  variant ? variant.PriceList.find(p => p.Account == 'PRICESRW') : null;
            let price = variant ? variant.PriceList[0] : null;
            return price ? price.Price - price.Price*discountGroup  : 0;

        }
        if (variant && variant.Active == 'V') {
            let price = variant.PriceList.find(p => p.Account != null && p.Account.indexOf('B2B'));
            let taxValue  = (100 + this.getTax(searchProduct)) / 100;

            return price ? Math.round(price.Price *  100 / taxValue) / 100 : 0;
        } else {
            let priceList = variant ? variant.IphPriceList : [];
            return priceList.length > 0 ? priceList[0].Price  : 0;
        }
    },

    getDetalBrutto(searchProduct) {
        let variant = this.getDefaultVariant(searchProduct);
        let priceList = variant ? variant.PriceList : [];
        let price =  priceList.find(p => p.Account	== "DETAL_BRUTTO");
        return price != null ? price.Price : 0;
    },

    getOfferBrutto(searchProduct) {
        let variant = this.getDefaultVariant(searchProduct);
        let priceList = variant ? variant.PriceList : [];
        let price =  priceList.find(p => p.Account	== "OFFER_NETTO");
        return price != null ? price.Price : 0;
    },


    getAttributes(searchProduct) {
        let variant = this.getDefaultVariant(searchProduct);
        return variant ? variant.AttributeList : null;
    },

    getAttributeValue(searchProduct, name) {
        let attribute = this.findAttribute(searchProduct, name);
        return attribute ? attribute.Value : '';
    },

    getDefaultVariant(searchProduct) {
        return searchProduct.VariantList.length > 0 ? searchProduct.VariantList[0] : null;
    },

    findAttribute(searchProduct, name) {
        let variant = this.getDefaultVariant(searchProduct);
        return variant ? variant.AttributeList.find((attr) => {return attr.AttributeProperty.Name == name}) : null;
    },

    getStock(searchProduct) {
        let variant = this.getDefaultVariant(searchProduct);
        let stockList = variant ? variant.StockList : [];
        return stockList.map(st => parseFloat(st.Quantity)).reduce((a, b) => a + b, 0)
    },

    getProducer(searchProduct) {
        return searchProduct.Producer.Name ?  searchProduct.Producer.Name : searchProduct.Producer.ShopName;
    },

    getProducerId(searchProduct) {
        return searchProduct.Producer.Id;
    },

    getEan(searchProduct) {
        let variant = this.getDefaultVariant(searchProduct);
        return variant ? variant.Ean1 : '';
    },
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/redbay-b2b-products/src/product/Product.js
// module id = pn3D
// module chunks = 0